/*
 * @Author: yidan.chen
 * @Date: 2025-04-02 10:51:10
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-04-02 10:53:32
 */
export const formatNumber = (
  value: number | string | undefined | null
): string | number => {
  if (!value) {
    return value === 0 || value === '0' ? 0 : '-'
  }
  const num = Number(value)
  if (isNaN(num)) return value
  return num.toLocaleString('en-US')
}

/**
 * Format as currency with thousand separators, but display '-' for empty or
 * invalid values (instead of '$0.00'). Used by BEFSummary, FleetBillingDetail, etc.
 */
export const formatCashNumber = (value: number | string) => {
  if (!value && value !== 0) return '-'
  // Strip commas before parsing so pre-formatted strings like '1,234.56' are valid.
  // Pass the resolved number to formatCurrency to decouple from its string-parsing internals.
  const num =
    typeof value === 'string' ? Number(value.replace(/,/g, '')) : Number(value)
  if (isNaN(num)) return '-'
  return formatCurrency(num)
}

/**
 * Format as currency WITH thousand separators: e.g. $1,234.56, -$1,234.56
 * Used by PaymentProof and anywhere comma-separated currency display is needed.
 */
export const formatCurrency = (
  value: string | number | undefined | null
): string => {
  if (value === undefined || value === null || value === '') return '$0.00'
  const num =
    typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value
  if (isNaN(num)) return '$0.00'
  const abs = Math.abs(num).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return num < 0 ? `-$${abs}` : `$${abs}`
}
